export default __webpack_public_path__ + "static/media/rent-second-img2.87340510.jpg";